const oldTeamData = [
  {
    draws: 3,
    goal_conceded: 4,
    goal_scored: 10,
    last_five: [],
    losses: 0,
    matchesPlayed: 7,
    name: "Bellicosa FC",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/bellicosa_team.jpeg",
    wins: 4,
    __v: 0,
    _id: "667073d545ebde78cffdd552",
  },
  {
    draws: 1,
    goal_conceded: 4,
    goal_scored: 7,
    last_five: [],
    losses: 2,
    matchesPlayed: 7,
    name: "Mango Marvels",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/mango_team.png",
    wins: 4,
    __v: 0,
    _id: "667073d545ebde78cffdd54f",
  },
  {
    draws: 2,
    goal_conceded: 9,
    goal_scored: 10,
    last_five: [],
    losses: 2,
    matchesPlayed: 7,
    name: "Feonn Furies",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/feon_team.jpg",
    wins: 3,
    __v: 0,
    _id: "667073d545ebde78cffdd550",
  },
  {
    draws: 3,
    goal_conceded: 9,
    goal_scored: 11,
    last_five: [],
    losses: 2,
    matchesPlayed: 7,
    name: "Sakori Smashers",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sakori_team.jpg",
    wins: 2,
    __v: 0,
    _id: "667073d545ebde78cffdd556",
  },
  {
    draws: 3,
    goal_conceded: 13,
    goal_scored: 9,
    last_five: [],
    losses: 2,
    matchesPlayed: 7,
    name: "Sejal Scorchers",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sejal_team.jpg",
    wins: 2,
    __v: 0,
    _id: "667073d545ebde78cffdd553",
  },
  {
    draws: 5,
    goal_conceded: 12,
    goal_scored: 13,
    last_five: [],
    losses: 1,
    matchesPlayed: 7,
    name: "Carron Capitals",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/carron_team.JPG",
    wins: 1,
    __v: 0,
    _id: "667073d545ebde78cffdd554",
  },
  {
    draws: 3,
    goal_conceded: 12,
    goal_scored: 7,
    last_five: [],
    losses: 3,
    matchesPlayed: 7,
    name: "Vandana Warriors",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/vandana_team.png",
    wins: 1,
    __v: 0,
    _id: "667073d545ebde78cffdd551",
  },
  {
    draws: 1,
    goal_conceded: 13,
    goal_scored: 9,
    last_five: [],
    losses: 5,
    matchesPlayed: 7,
    name: "Team Sagar",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sagar_sponsor.jpeg",
    wins: 1,
    __v: 0,
    _id: "667073d545ebde78cffdd555",
  },
];
export default oldTeamData;
